import script from "./LoginMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginMobile.vue?vue&type=script&setup=true&lang=js"

import "./LoginMobile.vue?vue&type=style&index=0&id=391382f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391382f2"]])

export default __exports__